import TicketTypeProvider from './TicketTypeContext';
import TicketType from "./TicketType"

let Index = () => {
    return (
        <TicketTypeProvider>
            <TicketType />
        </TicketTypeProvider>
    )
}

export default Index;